<template>
  <div class="box"
       @click="closeLangList">
    <div class="Section"
         :style="{ backgroundImage: `url(${bg})` }">
      <div class="Header">
        <div class="Header-logo"></div>
        <div class="Header-title">{{ $t(`nav.title`) }}</div>
       <div class="lang-btn"
            @click.stop="getLangList">
         <span class="lang-current">{{ currentLang }}</span>
         <i class="Header-select-logo"></i>
       </div>
       <div class="lang-list"
            v-if="langListShow">
       <span
           v-for="(value, key) in langMap"
           :key="key"
           @click="changeLang(key)"
           class="lang-selector"
       >
     {{ value }}
   </span>
       </div>
      </div>
      <a :href="this.appleStoreLink"
         target="_blank"
         @click="appleBtnADS">
        <img class="Apple-store"
             :class="'store-' + lang"
             :src="appleStoreBg"
             alt="" />
      </a>
      <a
          :href="this.googlePlayLink"
          target="_blank"
          @click="googleBtnADS">
        <img class="Google-store"
             :class="'store-' + lang"
             :src="googlePlayBg"
             alt="" />
      </a>
    </div>

    <div id="footer">
      <div><a target="_blank" :href="$t(`footer.privacy-url`)">{{  $t(`footer.privacy`) }}</a> | <a target="_blank" :href="$t(`footer.terms-url`)">{{  $t(`footer.terms`) }}</a></div>
      <div>{{  $t(`footer.copyright`) }}</div>
      <div>{{  $t(`footer.owner`) }}</div>
    </div>
  </div>
</template>
<script>
import { linkApi, getCesMoimgs } from '../api/index'
import Swiper from '../utils/swiper4.4.1/swiper'
import '../utils/swiper4.4.1/swiper.css'
export default {
  name: 'Home',
  data() {
    return {
      langListShow: false,
      langMap: {
        'en': "English",
        'de': "Deutsch",
        'fr': "Français",
        'es': "Español",
        'pt': "Português",
      },
      lang: '',
      imgsMoUrl: [],
      appleStoreLink: process.env.VUE_APP_APPLE_STORE_LINK || '',
      googlePlayLink: process.env.VUE_APP_GOOGLE_STORE_LINK || '',
      swiper: null,
    }
  },
  computed: {
    currentLang: function () {
      return this.langMap[this.lang];
    },
    text: function () {
      switch (this.lang) {
        case 'en':
          return require('../assets/imgs/en/text.png')
        case 'de':
          return require('../assets/imgs/de/text.png')
        case 'fr':
          return require('../assets/imgs/fr/text.png')
        case 'es':
          return require('../assets/imgs/es/text.png')
        case 'pt':
          return require('../assets/imgs/pt/text.png')
        default:
          return require('../assets/imgs/en/text.png')
      }
    },
    appleStoreBg: function () {
      switch (this.lang) {
        case 'en':
          return require('../assets/imgs/en/appleStoreBg.png')
        case 'de':
          return require('../assets/imgs/de/appleStoreBg.png')
        case 'fr':
          return require('../assets/imgs/fr/appleStoreBg.png')
        case 'es':
          return require('../assets/imgs/es/appleStoreBg.png')
        case 'pt':
          return require('../assets/imgs/pt/appleStoreBg.png')
        default:
          return require('../assets/imgs/en/appleStoreBg.png')
      }
    },
    googlePlayBg: function () {
      switch (this.lang) {
        case 'en':
          return require('../assets/imgs/en/googlePlayBg.png')
        case 'de':
          return require('../assets/imgs/de/googlePlayBg.png')
        case 'fr':
          return require('../assets/imgs/fr/googlePlayBg.png')
        case 'es':
          return require('../assets/imgs/es/googlePlayBg.png')
        case 'pt':
          return require('../assets/imgs/pt/googlePlayBg.png')
        default:
          return require('../assets/imgs/en/googlePlayBg.png')
      }
    },
    title: function () {
      switch (this.lang) {
        case 'en':
          return require('../assets/imgs/en/title.png')
        case 'de':
          return require('../assets/imgs/de/title.png')
        case 'fr':
          return require('../assets/imgs/fr/title.png')
        case 'es':
          return require('../assets/imgs/es/title.png')
        case 'pt':
          return require('../assets/imgs/pt/title.png')
        default:
          return require('../assets/imgs/en/title.png')
      }
    },
    logo: function () {
      switch (this.lang) {
        case 'en':
          return require('../assets/imgs/en/logo.png')
        case 'de':
          return require('../assets/imgs/de/logo.png')
        case 'fr':
          return require('../assets/imgs/fr/logo.png')
        case 'es':
          return require('../assets/imgs/es/logo.png')
        case 'pt':
          return require('../assets/imgs/pt/logo.png')
        default:
          return require('../assets/imgs/en/logo.png')
      }
    },
    bg: function () {
      switch (this.lang) {
        case 'en':
          return require('../assets/imgs/en/bg.png')
        case 'de':
          return require('../assets/imgs/de/bg.png')
        case 'fr':
          return require('../assets/imgs/fr/bg.png')
        case 'es':
          return require('../assets/imgs/es/bg.png')
        case 'pt':
          return require('../assets/imgs/pt/bg.png')
        default:
          return require('../assets/imgs/en/bg.png')
      }
    },
  },
  methods: {
    changeLang(url) {
      this.langListShow = false
      this.$router.push({ path: url })
          .then(() => {
            this.initLang()
            this.getImgsinfo()
            // 不使用完全刷新，而是通过组件内部更新状态
          })
          .catch(err => {
            if (err.name !== 'NavigationDuplicated') {
              console.error('导航错误:', err)
            } else {
              this.initLang()
              this.getImgsinfo()
            }
          })
    },
    closeLangList() {
      this.langListShow = false
    },
    getLangList() {
      this.langListShow = !this.langListShow
    },
    navigatorLanguage() {
      let navigatorLanguage = (navigator.language || navigator.browserLanguage).toLowerCase();
      let curentLang = "en";
      
      if (navigatorLanguage.indexOf("de") > -1) {
        curentLang = "de";
      } else if (navigatorLanguage.indexOf("fr") > -1) {
        curentLang = "fr";
      } else if (navigatorLanguage.indexOf("es") > -1) {
        curentLang = "es";
      } else if (navigatorLanguage.indexOf("pt") > -1) {
        curentLang = "pt";
      } else if (navigatorLanguage.indexOf("en") > -1) {
        curentLang = "en";
      }
      
      return curentLang;
    },
    initLang() {
      switch (this.$route.path.replace('/', '')) {
        case 'en':
          this.lang = 'en'
          break
        case 'de':
          this.lang = 'de'
          break
        case 'fr':
          this.lang = 'fr'
          break
        case 'es':
          this.lang = 'es'
          break
        case 'pt':
          this.lang = 'pt'
          break
      }
      if (this.lang === '') {
        this.changeLang(this.navigatorLanguage());
      } else {
        // 同步更新 i18n 的语言设置
        this.$i18n.locale = this.lang;
        localStorage.setItem("locale", this.lang);
      }
    },
    initSwiiperM() {
      const options = {
        effect: 'coverflow',
        slidesPerView: 'auto',
        roundLengths: true,
        loop: true,
        centeredSlides: true,
        slideToClickedSlide: true,
        allowTouchMove: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        autoplay: {
          autoplay: true,
          disableOnInteraction: false,
        },
        coverflowEffect: {
          rotate: 8,
          stretch: 20,
          depth: 30,
          modifier: 2,
          slideShadows: false,
        },
      }
      if (this.swiper) {
        this.swiper.destroy(true, true) //删除之前创建的swiper实例
      }
      this.swiper = new Swiper(this.$refs.p5swiper, options)
    },
    appleBtnADS() {
      if (window.location.href.indexOf('utm_source=fb') !== -1) {
        fbq('track', 'AddToCart');
      }
      if (window.location.href.indexOf('utm_source=tiktok') !== -1) {
        ttq.track('ClickButton', {
          content_id: 'apple_store_download',
          content_type: 'product',
          content_name: 'Apple Store Download'
        });
      }
      // if (window.location.href.indexOf('utm_source=google') !== -1) {
      //   window.gtag_report_conversion()
      //   window.gtag('config', 'AW-16638454849/zccdCKb-utQaEMHY6v09')
      //   window.gtag('js', new Date())
      // }
    },
    googleBtnADS() {
      if (window.location.href.indexOf('utm_source=fb') !== -1) {
        fbq('track', 'CompleteRegistration');
      }
      if (window.location.href.indexOf('utm_source=tiktok') !== -1) {
        ttq.track('AddToWishlist', {
          content_id: 'google_play_download',
          content_type: 'product',
          content_name: 'Google Play Download'
        });
      }
    },
    googlegtag() {
      if (window.location.href.indexOf('utm_source=google') !== -1) {
        window.gtag('config', 'AW-16638454849')
        window.gtag('js', new Date())
      }
    },
    getImgsinfo() {
      let _this = this
      let id = function () {
        switch (_this.lang) {
          case 'en':
            return process.env.VUE_APP_EN_ID || 300066238981105
          case 'de':
            return process.env.VUE_APP_DE_ID || process.env.VUE_APP_EN_ID || 300066238981105
          case 'fr':
            return process.env.VUE_APP_FR_ID || process.env.VUE_APP_EN_ID || 300066238981105
          case 'es':
            return process.env.VUE_APP_ES_ID || process.env.VUE_APP_EN_ID || 300066238981105
          case 'pt':
            return process.env.VUE_APP_PT_ID || process.env.VUE_APP_EN_ID || 300066238981105
          default:
            return process.env.VUE_APP_EN_ID || 300066238981105
        }
      }
      const params1 = {
        id: id(),
      }
      this.imgsMoUrl = []
      getCesMoimgs(params1)
        .then((res) => {
          this.imgsMoUrl = res.data.result.content
          setTimeout(() => {
            this.initSwiiperM()
          }, 100)
        })
        .catch((err) => {
          console.warn('获取图片信息失败，但不影响页面正常使用:', err.message || err)
        })
    },
  },
  mounted() {
    // this.getImgsinfo()
  },
  created() {
    this.initLang()
    window.px2rem()
    // this.googlegtag()
  },
}
</script>
<style scoped>
a {
  z-index: 3;
}
.Section {
  position: relative;
  width: 7.5rem;
  min-height: 13.34rem;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.lang-list {
  height: 3rem;
  width: 2.05rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  position: absolute;
  right: 0.3rem;
  top: 0.75rem;
  bottom: -1.68rem;
  background-color: rgba(2, 2, 2, 0.6);
}
.lang-list span {
  font-size: 0.32rem;
  color: #e1e0e0;
}
.lang-btn {
  position: absolute;
  right: 0.3rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 0.15rem;
  padding-right: 0.1rem;
  background: linear-gradient(180deg, #a37349, #ecdda3);
  border: 0.01rem solid #ddc690;
  border-radius: 0.1rem;
  height: 0.55rem;
}
.Header {
  height: 0.9rem;
  width: 7.5rem;
  background: black;
  position: relative;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: stretch;
}
.Header-logo{
  margin-left: 0.2rem;
  border-radius: 0.15rem;
  width: 0.7rem;
  height: 0.7rem;
  background-size: cover;
  background: url('~@/assets/imgs/logo.png') no-repeat center;
  background-size: 100% 100%;
}
.Header-title{
  position: absolute;
  left: 1.05rem;
  font-weight: bold;
  text-transform: uppercase;
  color: #ced4d5;
  font-size: 0.24rem;
}
.lang-current {
  width: 1.5rem;
  text-align: center;
  font-size: 0.32rem;
  color: #70421a;
  text-shadow: #d2b783 0.01rem 0 0.01rem,#d2b783 -0.01rem 0 0.01rem,#d2b783 0 -0.01rem 0.01rem,#d2b783 0 0.01rem 0.01rem;
}
.Header-select-logo {
  display: inline-block;
  width: 0.28rem;
  height: 0.25rem;
  background: url('~@/assets/imgs/triangle.png');
  background-size: 100% 100%;
}
.Apple-store {
  float: left;
  position: absolute;
  top: 11.25rem;
  left: 0.53rem;
  right: 1.53rem;
}
.store-en,
.store-de,
.store-fr,
.store-es,
.store-pt {
  width: 2.76rem;
  height: 0.8rem;
}
.Google-store {
  float: right;
  position: absolute;
  top: 11.25rem;
  left: 3.99rem;
  right: 1.53rem;
}

#footer {
  position: absolute;
  top: 12.5rem;
  width: 7.5rem;
  display: flex;
  font-size: 0.14rem;
  color: #ced4d5;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}
#footer a{
  color: #ced4d5;
}
#footer a:visited{
  color: #ced4d5;
}
#footer a:hover{
  color: #ced4d5;
}
#footer a:link{
  color: #ced4d5;
}
</style>
